import React from 'react';
import { motion } from 'framer-motion';

const EducationCenter = () => {
  return (
    <div className="min-h-[80vh]  flex items-center justify-center">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center p-8 bg-white max-w-2xl mx-4"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="text-6xl mb-6"
        >
          🎓
        </motion.div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Education Center</h1>
        <p className="text-xl text-gray-600 mb-8">Coming Soon!</p>
        <p className="text-gray-500">
          We're working hard to bring you valuable educational content. Stay tuned for updates!
        </p>
      </motion.div>
    </div>
  );
};

export default EducationCenter; 